import React from "react";
import { history, useIntl } from "umi";
import { Button, notification } from "antd";

// @ts-ignore
import ding from '@/assets/audios/new_task_remind.wav';
import type { TaskMessage } from "@/pages/Inquiry/data";

const key = 'newTask';

const MessageNotice: React.FC = () => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.RightContent.MessageNotice', intl.formatMessage);

  // const { initWebsocket } = useModel('task');

  // useEffect(() => {
  //   initWebsocket(MessageInfo);
  // }, []);
  const btn = (
    <Button type="primary" onClick={() => {
      notification.close(key);
      history.push({
        pathname: '/task/task-view/process',
        query: { newTask: new Date().getTime().toString() }
      })
    }}>
      {t('t0', '查看')}
    </Button>
  )

  const MessageInfo = (info: TaskMessage) => {
    if (info?.biz !== 'TASK_NEW') return
    notification.info({
      message: t('t1', '新任务提醒'),
      description: info?.content?.text || t('t2', '您收到一条新任务，点击查看吧~'),
      btn,
      key,
      duration: 0,
      placement: 'bottomRight'
    });
    const audio = new Audio(ding);
    audio.volume = 0.4;
    audio.play();
  }

  return (
    <></>
  );
}

export default MessageNotice;